import React from "react";
import { connect } from "react-redux";
import { isBusy, withActions } from "actionware";
import { getTranslate } from "react-localize-redux";
import { Button, Row, Col, Spin } from "antd";
import { push } from "connected-react-router";
import _ from "lodash";

import SuccessTickMark from "../../assets/green_tick_mark.svg";
import ErrorTickMark from "../../assets/red_tick_mark.svg";

import Close from "../../assets/close.svg";

import {
  getFundingCycle,
  setCurrentViewPage,
  resetToInitialState,
  toggleBannerView,
  toggleErrorCard,
} from "./fundingLimitActions.js";

import "./fundingLimit.less";
import SetupFundingCycle from "./setupFundingCycle";
import FundingCard from "../fundingLimit/fundingLimitComponents/fundingCard.jsx";
import { bindActionCreators } from "redux";
import LenderRanking from "./lenderRanking";
import {
  MONTHS,
  SHOW_LENDER_RANKING_VIEW_FLAG,
  SHOW_NEW_CYCLE_VIEW_FLAG,
} from "./constants";
import InlineSVG from "react-inlinesvg";
import ErrorCard from "../../components/errorCard/errorCard.jsx";

@connect(
  ({
    localize,
    funding: {
      action,
      fundingCycle,
      showLenderRankingView,
      showNewCycleView,
      bannerDetails,
      errorCard,
    },
  }) => ({
    translate: getTranslate(localize),
    action,
    fundingCycle,
    showLenderRankingView,
    showNewCycleView,
    bannerDetails,
    errorCard,
    loading:
      (isBusy(getFundingCycle) || _.isEmpty(fundingCycle)) &&
      !errorCard.errorCardVisible,
  }),
  (dispatch) => {
    return bindActionCreators({ push }, dispatch);
  }
)
@withActions({
  getFundingCycle,
  setCurrentViewPage,
  resetToInitialState,
  toggleBannerView,
  toggleErrorCard,
})
class FundingLimit extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      currentPage: 1,
      nextPage: -1,
      prevPage: -1,
      role: "",
    };
    this.closeBanner = this.closeBanner.bind(this);
  }

  async componentDidMount() {
    this.props.getFundingCycle();
  }

  async componentDidUpdate(prevProps) {
    const { fundingCycle } = this.props;
    if (
      prevProps.fundingCycle !== fundingCycle &&
      _.isEmpty(fundingCycle) &&
      !prevProps.errorCard.errorCardVisible
    ) {
      this.props.getFundingCycle();
    }
  }

  setViewClicked = (viewEnabled) => {
    this.props.setCurrentViewPage({
      [viewEnabled]: true,
    });
  };

  closeBanner = () => {
    this.props.toggleBannerView({ showFlag: false, title: "" });
  };

  retryGetRequest = () => {
    this.props.toggleErrorCard({
      api: "",
      flag: false,
    });
    this.props.getFundingCycle();
  };

  renderFundingLimitTitle = () => {
    const { translate, fundingCycle } = this.props;
    const date = new Date(fundingCycle.cycle_start_time);
    let month = MONTHS[date.getMonth()];
    let year = date.getFullYear();

    return (
      <Row className="funding-limit-title">
        <Col span={4} className="funding-limit-title-name">
          {translate("fundingLimit.ovo_admin_heading_funding_limit")}
        </Col>
        <Col span={4} className="funding-limit-title-date">
          {month} {year} - {translate("fundingLimit.present")}
        </Col>
        <Col span={9} offset={7} className="funding-limit-title-btns">
          {this.renderActionableItems()}
        </Col>
      </Row>
    );
  };

  renderActionableItems = () => {
    const { translate } = this.props;
    return (
      <div>
        <Button
          type="secondary"
          onClick={() => this.setViewClicked(SHOW_LENDER_RANKING_VIEW_FLAG)}
        >
          {translate(
            "fundingLimit.ovo_admin_button_edit_lender_ranking_funding_limit"
          )}
        </Button>
        <Button
          type="primary"
          onClick={() => this.setViewClicked(SHOW_NEW_CYCLE_VIEW_FLAG)}
        >
          {translate("fundingLimit.ovo_admin_button_new_cycle_funding_limit")}
        </Button>
      </div>
    );
  };

  renderFundingLimitHomePageData = () => {
    const { fundingCycle } = this.props;
    return (
      <div className="funding-parent-container">
        {_.map(fundingCycle.product_details, (data, key) => {
          return <FundingCard index={key} cardDetail={data} />;
        })}
      </div>
    );
  };

  renderBanner = () => {
    const {
      bannerDetails: { isBannerVisible, bannerTitle, isErrorBanner },
      translate,
    } = this.props;
    let bannerTick = isErrorBanner ? ErrorTickMark : SuccessTickMark;
    let bannerBg = isErrorBanner
      ? "banner-container banner-error"
      : "banner-container banner-success";
    if (isBannerVisible) {
      return (
        <div className={bannerBg}>
          <div className="banner-icon-container">
            <InlineSVG src={bannerTick}></InlineSVG>
            <div className="banner-text">{translate(bannerTitle)}</div>
          </div>
          <div className="banner-close" onClick={this.closeBanner}>
            <InlineSVG src={Close}></InlineSVG>
          </div>
        </div>
      );
    }
  };

  renderHomePageView = () => {
    const { translate, errorCard } = this.props;
    if (errorCard.errorCardVisible) {
      return (
        <div className="error-card-container">
          <ErrorCard
            title={translate("homePage.heading_something_went_wrong")}
            caption={translate(
              "homePage.mex_lender_body_retry_come_back_error"
            )}
            buttonText={translate("homePage.button_retry")}
            buttonClickHandler={this.retryGetRequest}
          />
        </div>
      );
    }
    return (
      <>
        {this.renderFundingLimitTitle()}
        {this.renderBanner()}
        {this.renderFundingLimitHomePageData()}
      </>
    );
  };

  renderNewCycleView = () => {
    return <SetupFundingCycle />;
  };

  renderEditLenderRankingView = () => {
    return <LenderRanking isEditLenderRanking={true} {...this.props} />;
  };

  render() {
    const { translate, loading, showLenderRankingView, showNewCycleView } =
      this.props;
    if (loading) {
      return <Spin tip={translate("generic.loadingData")} size="large" />;
    } else if (!showLenderRankingView && !showNewCycleView) {
      return this.renderHomePageView();
    } else if (showNewCycleView) {
      return this.renderNewCycleView();
    } else if (showLenderRankingView) {
      return this.renderEditLenderRankingView();
    }
  }
}

export default FundingLimit;
